<template>
  <div class="basic-info-container">
    <el-form ref="form" :rules="rules" :model="form" label-width="180px">
      <el-form-item label="任务名称：" prop="name">
        <el-input v-model="form.name" maxlength="50" placeholder="请输入任务名称"></el-input>
      </el-form-item>
      <el-form-item label="输入要采集的网址：" prop="url">
        <el-input v-model="form.url" maxlength="255" placeholder="请输入网址"></el-input>
      </el-form-item>
      <el-form-item label="选择栏目：" prop="channelId">
        <el-tree
          ref="collectTree"
          :data="ChannelList"
          :props="defaultProps"
          highlight-current
          node-key="id"
          :default-expanded-keys="defaulCheckedKeys"
          accordion
          v-loading="channelLoading"
          @node-click="handleNodeClick"></el-tree>
      </el-form-item>

      <el-form-item label="选择内容模型：" prop="modelId">
        <el-select popper-class="basic-dropdown" style="width: 100%" v-model="modelIdIndex" placeholder="请选择" @change="changeModel">
          <el-option
            v-for="(item, index) in ModelOptions"
            :key="item.id"
            :label="item.modelName"
            :value="index">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="nextGoto">下一步</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { getTreeIds } from '@/utils'
export default {
  name: 'BasicInfo',
  data () {
    return {
      ChannelList: [], // 栏目选项
      ModelOptions: [], // 内容模型选项
      channelModels: {}, // 栏目与内容模型级联关系
      id: '', // 云端ID
      appid: '', // 客户端
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      channelLoading: true, // 栏目 loading
      defaulCheckedKeys: [], // 设置默认打开的栏目
      modelIdIndex: '', // 默认选中模型
      // 表单验证
      rules: {
        name: [
          { required: true, message: '请输入任务名称', trigger: 'blur' },
          { validator: this.fetchNameCheck, trigger: 'blur' }
        ],
        url: [
          { required: true, message: '请输入需要采集的网址', trigger: 'blur' },
          { type: 'url', message: '请输入正确的采集网址', trigger: 'blur' }
        ],
        channelId: [
          { required: true, message: '请选择底层栏目', trigger: 'change' }
        ],
        modelId: [
          { required: true, message: '请选择内容模型', trigger: 'change' }
        ]
      }
    }
  },
  props: ['value', 'modelFields', 'collectType', 'linkName'],
  computed: {
    form: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  watch: {
    // 'form': function () {
    //   if (this.collectType === 'edit') {
    //     this.setDefaultData()
    //   }
    // },
    'form.name' (newVal, oldVal) {
      if (this.$route.query.taskId !== undefined && newVal === this.linkName) {
        this.rules.name = [
          { required: true, message: '请输入任务名称', trigger: 'blur' }
        ]
      } else {
        this.rules.name = [
          { required: true, message: '请输入任务名称', trigger: 'blur' },
          { validator: this.fetchNameCheck, trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    this.id = window.localStorage.getItem('identity')
    this.appid = window.localStorage.getItem('appId')
    // 修改
    // this.id = '899601769511387296'
    // this.appid = '3aYBO*3bzQ5g3bAk5f3YMk9g'
    setTimeout(() => {
      console.log(this.value,'this.value');
      this.getCmsData()
    }, 150);
    // 判断是否有 taskId, 如果有就把任务名称传给中间值
    if (this.$route.query.taskId !== undefined) {
      this.rules.name = [
        { required: true, message: '请输入任务名称', trigger: 'blur' }
      ]
    }
    // if (this.collectType === 'edit') {
    //   this.setDefaultData()
    // }
  },
  methods: {
    // 校验重复
    fetchNameCheck (rule, value, callback) {
      if (value) {
        this.$request.fetchNameCheck({ 'appId': this.appid, 'name': value, 'identity': this.id }).then(res => {
          if (res.code === 200 && res.data) {
            callback()
          } else {
            callback(new Error('任务名称不能重复'))
          }
        })
      } else {
        callback()
      }
    },
    // 编辑页面 绑定数据
    setDefaultData () {
      let _this = this
      console.log(_this.form,'setDefaultDataform');
      // console.log(_this.ModelOptions,'_this.ModelOptions');
      setTimeout(function () {
        _this.defaulCheckedKeys.push(_this.form.channelId)
        _this.$refs.collectTree.setCurrentKey(_this.form.channelId)
        console.log(_this.form.modelId,'_this.form.modelId');
        console.log('_this.ModelOptions:', _this.ModelOptions);
        _this.modelIdIndex = _this.ModelOptions.findIndex((v) => {
          if (v.id === _this.form.modelId) {
            return v
          }
        })
        console.log(_this.modelIdIndex,'_this.modelIdIndex');
        if(_this.modelIdIndex == -1) {
          _this.modelIdIndex = ''
        }else if (_this.modelIdIndex > -1) {
          _this.$emit('change-model-fields', _this.ModelOptions[_this.modelIdIndex].modelFields)
        }
      }, 100)
    },
    changeModel (item) {
      this.setModel()
    },
    // 设置模型
    setModel () {
      // console.log(this.modelIdIndex,'this.modelIdIndex');
      // console.log(this.form.modelId,'this.form.modelId');
      // console.log(this.ModelOptions);
      // console.log(this.ModelOptions[this.modelIdIndex],'this.ModelOptions[this.modelIdIndex]');
      if (this.ModelOptions[this.modelIdIndex]) {
        this.form.modelId = getTreeIds(this.ModelOptions, this.ModelOptions[this.modelIdIndex].id)[0]
        this.$emit('change-model-fields', this.ModelOptions[this.modelIdIndex].modelFields)
      } else {
        this.form.modelId = ''
      }
    },
    // 下一步
    nextGoto () {
      if(!this.form.channelId) {
        this.$message.error('请选择底层栏目')
        return false
      }
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.$emit('change-name', 'dispose')
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 设置栏目
    getCmsData () {
      console.log(this.form,'getCmsData,this.form');
      this.$request.getClientData({ 'id': this.id, 'appid': this.appid }).then(res => {
        this.channelLoading = false
        if (res.code === 200) {
          console.log(res, 'ressss');
          this.ChannelList = res.data.channels
          this.channelModels = res.data.channelModels
          if(this.collectType === 'add') {
            this.ModelOptions = []
            console.log('新建Options', this.ModelOptions);
          }else {
            console.log(this.form.channelId,'this.form.channelId');
            this.ModelOptions = this.channelModels[this.form.channelId] || []
            console.log(this.ModelOptions,'编辑this.ModelOptions');
            this.setDefaultData()
          }
          // if (this.collectType === 'add') {
          //   this.setModel()
          // }
        }
      })
    },
    // 获取栏目ID
    handleNodeClick (data) {
      this.form.channelId = ''
      this.modelIdIndex = ''
      if (data.isBottom) {
        this.form.channelId = data.id
        this.ModelOptions = this.channelModels[data.id]
      }
    }
  }
}
</script>

<style scoped lang="scss">
.basic-info-container{
  width: 650px;
  /deep/ .el-form-item{
    .el-form-item__label{
      font-size:14px;
      color:rgba(102,102,102,1);
    }
    .el-checkbox{
      display: inline-block;
    }
    .el-tree-node.is-current > .el-tree-node__content {
      background-color: #F0F0F0 !important;
      color: #1EC6DF;
      //          // 采集修改
    }

    .el-tree {
      border:1px solid rgba(232,232,232,1);
      border-radius:4px;
      padding: 10px 0;
      height: 438px;
      overflow-y: auto;
      .el-tree-node__content{
        height: 32px;
      }
    }
    .el-button {
      height: 32px;
      padding: 0 20px;
    }
  }
}

</style>
<style>
.basic-dropdown{
  border-color: #1ec6df!important;
}
</style>
<style scoped type="text/css">
  .el-form-item .is-current {
    background-color: #edfafc !important;
  }
</style>
